export const QUICK_LAUNCH_ASSET_TYPES = new Set([
  'article',
  'image',
  'video',
  'collection',
  'poll',
  'audio',
  'file',
  'link',
  'table',
  'html',
]);
